var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('navbar-for-guest',{on:{"logout":_vm.logout}}),_c('div',{staticClass:"nuxt_container"},[_c('ApplicationErrorAlert'),_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }